import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Star, CheckCircle2, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { ReviewForm } from "@/components/review/ReviewForm";

export default function LeaveReview() {
  const [params] = useSearchParams();
  const [google, setGoogle] = useState("");
  const [done, setDone] = useState(null);
  useEffect(() => { api.get("/reviews/links").then((r) => setGoogle(r.data.google_review_url || "")).catch(() => {}); }, []);

  const googleBtn = google && (
    <a href={google} target="_blank" rel="noreferrer" className="dg-btn-ghost rounded-full px-5 py-3 min-h-[44px] text-sm inline-flex items-center justify-center gap-2" data-testid="review-google-btn">
      <ExternalLink className="w-4 h-4" /> Review us on Google
    </a>
  );

  if (done) {
    return (
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-16">
        <div className="dg-card rounded-2xl p-8 text-center dg-reveal" data-testid="review-thanks">
          <div className="w-14 h-14 rounded-full bg-[#FFD600]/10 border border-[#FFD600]/40 grid place-items-center mx-auto"><CheckCircle2 className="w-7 h-7 text-[#FFD600]" /></div>
          <h1 className="font-display text-2xl font-bold mt-4">Thank you, {done.name.split(" ")[0]}.</h1>
          <p className="text-slate-300 mt-2">David reads every review himself. Yours will show up on the home page once he's seen it — usually within a day.</p>
          {google && <p className="text-slate-400 text-sm mt-6">Have one more minute? The same words on Google help other people find real, reachable tech help.</p>}
          <div className="mt-5 flex flex-col sm:flex-row justify-center gap-3">
            {googleBtn}
            <Link to="/" className="dg-btn-primary rounded-full px-5 py-3 min-h-[44px] text-sm inline-flex items-center justify-center" data-testid="review-home-btn">Back home</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-12" data-testid="review-page">
      <div className="mb-8 dg-reveal">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-[#FFD600]/10 border border-[#FFD600]/40 grid place-items-center"><Star className="w-5 h-5 text-[#FFD600]" /></div>
          <span className="dg-eyebrow">Reviews</span>
        </div>
        <h1 className="mt-3 text-3xl sm:text-4xl font-extrabold font-display tracking-tight">How did we do?</h1>
        <p className="mt-3 text-slate-300">Worked with David — on the phone, on video, or on an install? Tell people how it went. Your words go on the home page after David reads them.</p>
        {google && <div className="mt-5 flex flex-wrap items-center gap-3"><span className="text-sm text-slate-400">Prefer Google?</span>{googleBtn}</div>}
      </div>
      <ReviewForm initialName={params.get("name") || ""} onDone={setDone} />
    </div>
  );
}
